import { BeverageStockPage } from './beverage-stock/BeverageStockPage'
import { ReorderDraftsPage } from './reorder-drafts/ReorderDraftsPage'
import { StockPage } from './stock/StockPage'
import { SupplierComparisonPage } from './supplier-comparison/SupplierComparisonPage'
import { CompaniesPage } from './suppliers/CompaniesPage'
import { ExternalCompaniesPage } from './suppliers/ExternalCompaniesPage'
import { SuppliersPage } from './suppliers/SuppliersPage'

/**
 * `manager-inventory` — the stock room: items and movements, beverages, suppliers,
 * their price comparison, and reorder drafts.
 *
 * Ported: all five — stock, beverage-stock, suppliers, supplier-comparison,
 * reorder-drafts.
 *
 * Owed on `/stock`: the OCR
 * goods-receipt import (`POST /stock/receipts/ocr` → `POST /stock/receipts`), which
 * is its own line-matching flow and is listed in the page spec rather than dropped.
 *
 * A quantity here is **not** money. §14.7 governs amounts somebody pays; stock is
 * counted in fractional kilograms and litres, and a purchase price is a per-unit
 * rate that keeps every decimal it was quoted with (FB-056).
 */
export const managerInventoryModule = {
  name: 'manager-inventory',
  routes: [
    {
      path: '/stock',
      page: 'stock',
      guard: { permission: 'stock' },
      component: StockPage,
    },
    {
      path: '/beverage-stock',
      page: 'beverage-stock',
      guard: { permission: 'beverage_stock', franchiseModule: 'stock.beverage' },
      component: BeverageStockPage,
    },
    {
      // *Externé Firmy* - §9.347, the owner's C2. The hub draws *Dodávatelia* and *Firmy* as tabs, so
      // this route gates on **either** permission: gating it on `suppliers` alone would refuse
      // somebody who holds only the outgoing-invoice right while the sidebar still offered it, which
      // is FB-001's shape. Each tab keeps its own gate, tier included.
      path: '/suppliers',
      page: 'suppliers',
      guard: { anyPermission: ['suppliers', 'outgoing_invoices'] },
      component: ExternalCompaniesPage,
    },
    {
      // The Firmy list on its own, because §9.208's rule is that a hub must not be a wall in front of
      // a page somebody has bookmarked.
      path: '/invoice-companies',
      page: 'invoice-companies',
      guard: { permission: 'outgoing_invoices', franchiseModule: 'invoices.outgoing' },
      component: CompaniesPage,
    },
    {
      path: '/supplier-comparison',
      page: 'supplier-comparison',
      guard: { permission: 'supplier_comparison', franchiseModule: 'suppliers.comparison' },
      component: SupplierComparisonPage,
    },
    {
      path: '/reorder-drafts',
      page: 'reorder-drafts',
      guard: { permission: 'reorder_drafts', franchiseModule: 'reorder_drafts' },
      component: ReorderDraftsPage,
    },
  ],
} as const

export {
  BeverageStockPage,
  ReorderDraftsPage,
  StockPage,
  SupplierComparisonPage,
  SuppliersPage,
}
